import React from 'react';
import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <div>
      <section style={{ background:'#0B1F3A', padding:'5rem 2.5rem 4rem' }}>
        <div style={{ maxWidth:'1100px', margin:'0 auto', display:'grid',
          gridTemplateColumns:'1fr 1fr', gap:'4rem', alignItems:'center' }}>
          <div>
            <div style={{ display:'inline-flex', alignItems:'center', gap:'8px',
              background:'rgba(46,189,138,0.12)', border:'1px solid rgba(46,189,138,0.3)',
              color:'#2EBD8A', fontSize:'0.72rem', letterSpacing:'2px', textTransform:'uppercase',
              padding:'0.4rem 1rem', borderRadius:'100px', marginBottom:'1.8rem' }}>
              <span style={{ width:'6px', height:'6px', borderRadius:'50%',
                background:'#2EBD8A', display:'inline-block' }}></span>
              H1B & Green Card · No Lawyer Required
            </div>
            <h1 style={{ fontFamily:"'Bebas Neue', sans-serif", fontSize:'clamp(3rem,7vw,6rem)',
              lineHeight:0.93, letterSpacing:'2px', color:'#F7F8FA', marginBottom:'1.5rem' }}>
              YOUR VISA.<br/>
              <span style={{ color:'#2EBD8A' }}>YOUR RULES.</span><br/>
              NO LAWYER.
            </h1>
            <p style={{ fontSize:'1rem', color:'#8A9BB0', lineHeight:1.7,
              marginBottom:'2rem', maxWidth:'440px' }}>
              The TurboTax for US immigration. Step-by-step AI guidance for H1B
              and employer-sponsored green cards — at a fraction of what lawyers charge.
            </p>
            <div style={{ display:'flex', gap:'1rem', marginBottom:'2rem', flexWrap:'wrap' }}>
              <Link to="/start" style={{ background:'#1A9068', color:'#F7F8FA',
                padding:'0.9rem 2rem', borderRadius:'6px', fontSize:'0.95rem',
                fontWeight:500, textDecoration:'none' }}>Start my case →</Link>
              <Link to="/perm-lookup" style={{ background:'transparent', color:'#F7F8FA',
                border:'1px solid #2E5F8A', padding:'0.9rem 2rem', borderRadius:'6px',
                fontSize:'0.95rem', textDecoration:'none' }}>Look up my PERM →</Link>
            </div>
            <div style={{ display:'flex', gap:'1.5rem', flexWrap:'wrap' }}>
              {['12,000+ immigrants served','No law firm needed','All nationalities'].map(t => (
                <span key={t} style={{ fontSize:'0.78rem', color:'#4A87B8' }}>
                  <span style={{ color:'#2EBD8A' }}>✓</span> {t}
                </span>
              ))}
            </div>
          </div>

          <div style={{ background:'#1A3A5C', borderRadius:'12px',
            border:'1px solid #2E5F8A', padding:'1.5rem' }}>
            <div style={{ fontSize:'0.72rem', letterSpacing:'2px', textTransform:'uppercase',
              color:'#4A87B8', marginBottom:'1.2rem' }}>Your H1B case · In progress</div>
            {[
              { n:1, label:'Tell us your situation', done:true },
              { n:2, label:'Get your roadmap', done:true },
              { n:3, label:'Fill forms with AI guidance', active:true },
              { n:4, label:'Review & file', pending:true },
            ].map((step, i) => (
              <div key={i}>
                <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
                  <div style={{ width:'28px', height:'28px', borderRadius:'50%',
                    display:'flex', alignItems:'center', justifyContent:'center',
                    fontSize:'0.72rem', fontWeight:500, flexShrink:0,
                    background: step.done ? '#1A9068' : step.active ? '#2EBD8A' : '#2E5F8A',
                    color: step.active ? '#0B1F3A' : '#F7F8FA' }}>
                    {step.done ? '✓' : step.n}
                  </div>
                  <span style={{ fontSize:'0.85rem',
                    color: step.done ? '#8A9BB0' : step.active ? '#F7F8FA' : '#4A87B8',
                    textDecoration: step.done ? 'line-through' : 'none',
                    fontWeight: step.active ? 500 : 400 }}>
                    {step.label}
                  </span>
                </div>
                {i < 3 && <div style={{ width:'2px', height:'10px',
                  background:'#2E5F8A', margin:'2px 0 2px 13px' }}></div>}
              </div>
            ))}
            <div style={{ marginTop:'1.5rem', paddingTop:'1rem', borderTop:'1px solid #2E5F8A',
              display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div>
                <div style={{ fontSize:'0.75rem', color:'#4A87B8' }}>You're saving</div>
                <div style={{ fontSize:'0.85rem', fontWeight:500, color:'#2EBD8A' }}>$8,400 vs. a lawyer</div>
              </div>
              <span style={{ background:'rgba(46,189,138,0.1)', border:'1px solid rgba(46,189,138,0.2)',
                color:'#2EBD8A', fontSize:'0.72rem', padding:'0.3rem 0.8rem', borderRadius:'100px' }}>
                75% complete
              </span>
            </div>
          </div>
        </div>
      </section>

      <div style={{ background:'#F0F4FF', borderLeft:'3px solid #4A87B8',
        padding:'0.9rem 2.5rem', fontSize:'0.78rem', color:'#1A3A5C' }}>
        This is a self-help tool, not legal advice. You are always in control of your own filing — just like TurboTax for taxes.
      </div>

      <div style={{ background:'#0D6B4F' }}>
        <div style={{ maxWidth:'1100px', margin:'0 auto',
          display:'grid', gridTemplateColumns:'repeat(3,1fr)' }}>
          {[
            { num:'$0', label:'Attorney fees to file your H1B' },
            { num:'3 MIN', label:'To know exactly what forms you need' },
            { num:'$8K', label:'Average savings vs. a lawyer' },
          ].map((stat, i) => (
            <div key={i} style={{ padding:'2rem 2.5rem', textAlign:'center',
              borderRight: i < 2 ? '1px solid rgba(255,255,255,0.1)' : 'none' }}>
              <div style={{ fontFamily:"'Bebas Neue', sans-serif", fontSize:'3rem',
                color:'#F7F8FA', lineHeight:1 }}>{stat.num}</div>
              <div style={{ fontSize:'0.8rem', color:'rgba(247,248,250,0.65)',
                marginTop:'0.3rem' }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <section style={{ maxWidth:'1100px', margin:'0 auto', padding:'4rem 2.5rem' }}>
        <div style={{ fontSize:'0.72rem', letterSpacing:'3px', textTransform:'uppercase',
          color:'#1A9068', marginBottom:'0.8rem' }}>What we cover</div>
        <h2 style={{ fontFamily:"'Bebas Neue', sans-serif", fontSize:'clamp(2rem,4vw,3rem)',
          color:'#0B1F3A', marginBottom:'2.5rem' }}>Pick your process</h2>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))',
          gap:'1px', background:'#E8ECF2', borderRadius:'10px', overflow:'hidden',
          border:'1px solid #E8ECF2' }}>
          {[
            { icon:'🛂', title:'H1B Visa', desc:'Lottery, cap, filing, extensions, and transfers.', tag:'Most popular', featured:true, link:'/start' },
            { icon:'🟢', title:'Green Card EB-2 / EB-3', desc:'PERM → I-140 → I-485 in plain English.', tag:'Employer sponsored', link:'/start' },
            { icon:'🔍', title:'PERM Intelligence', desc:'Look up your PERM case. See wage level and red flags for free.', tag:'Free tool', link:'/perm-lookup' },
            { icon:'📅', title:'Priority Date Tracker', desc:'Live Visa Bulletin. Know where you stand.', tag:'Updated monthly', link:'/start' },
            { icon:'⚖️', title:'AC21 Portability', desc:'Changing jobs while your green card is pending?', tag:'Job change', link:'/start' },
            { icon:'🚀', title:'EB-2 NIW', desc:'Self-petition. No employer needed.', tag:'Self-sponsored', link:'/start' },
          ].map((p, i) => (
            <Link key={i} to={p.link} style={{ background:'#fff', padding:'1.8rem',
              textDecoration:'none', display:'block',
              borderLeft: p.featured ? '3px solid #1A9068' : '3px solid transparent' }}>
              <div style={{ fontSize:'1.4rem', marginBottom:'1rem' }}>{p.icon}</div>
              <div style={{ fontSize:'0.95rem', fontWeight:500, color:'#0B1F3A',
                marginBottom:'0.4rem' }}>{p.title}</div>
              <div style={{ fontSize:'0.8rem', color:'#8A9BB0', lineHeight:1.6,
                marginBottom:'0.8rem' }}>{p.desc}</div>
              <span style={{ display:'inline-block', fontSize:'0.68rem', letterSpacing:'1px',
                textTransform:'uppercase', padding:'0.25rem 0.6rem', borderRadius:'3px',
                background: p.featured ? 'rgba(26,144,104,0.08)' : '#F0F4FF',
                color: p.featured ? '#0D6B4F' : '#1A3A5C' }}>{p.tag}</span>
            </Link>
          ))}
        </div>
      </section>

      <section style={{ background:'#1A9068', padding:'4rem 2.5rem', textAlign:'center' }}>
        <h2 style={{ fontFamily:"'Bebas Neue', sans-serif", fontSize:'clamp(2rem,5vw,3.5rem)',
          letterSpacing:'2px', color:'#F7F8FA', marginBottom:'0.8rem' }}>
          Ready to ditch the lawyer?
        </h2>
        <p style={{ color:'rgba(247,248,250,0.7)', fontSize:'0.95rem', marginBottom:'2rem' }}>
          Join thousands of immigrants who filed on their own — and kept their money.
        </p>
        <Link to="/start" style={{ background:'#F7F8FA', color:'#0D6B4F',
          padding:'0.9rem 2.5rem', borderRadius:'6px', fontSize:'0.95rem',
          fontWeight:500, textDecoration:'none' }}>
          Start my case for free →
        </Link>
      </section>

      <footer style={{ background:'#0B1F3A', padding:'1.8rem 2.5rem', textAlign:'center',
        fontSize:'0.75rem', color:'#2E5F8A' }}>
        © 2026 noimmigrationlawyers.com · Not a law firm · Not legal advice ·{' '}
        <span style={{ color:'#4A87B8' }}>Built for immigrants, by someone who's been there.</span>
      </footer>
    </div>
  );
}